const getCookie = (name: string): string => {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : ''
}

interface SetCookieOptions { maxAgeInSeconds?: number }

function buildCookieString (name: string, value: string, options: SetCookieOptions = {}): string {
  const maxAgeString = options.maxAgeInSeconds ? `;max-age=${options.maxAgeInSeconds}` : ''
  return `${name}=${value}${maxAgeString};path=/`
}

function setCookie (name: string, value: string, options: SetCookieOptions = {}): void {
  document.cookie = buildCookieString(name, value, options)
}

export {
  buildCookieString,
  setCookie,
  getCookie,
}
